export default __webpack_public_path__ + "static/media/avatar.030b68cd.png";